import React from 'react'
import { FormattedMessage } from 'sb-react-intl'

import Picture from 'components/ui/Picture/Picture'
import OpenUpgradeButton from 'components/buttons/UpgradeButton/OpenUpgradeButton/OpenUpgradeButton'

import messages from './messages'
import s from './QueueUpgradeSubscription.scss'

import gatesImage from './images/gates.svg'


const QueueUpgradeSubscription = () => (
  <div className={s.upgradeSubscription}>
    <FormattedMessage className={s.title} tag="div" {...messages.title} />
    <FormattedMessage className={s.desc} tag="div" {...messages.desc} />
    <OpenUpgradeButton placement="queue" snowplowPlacement="queue" />
    <Picture className={s.picture} src={gatesImage} />
  </div>
)


export default QueueUpgradeSubscription
